import React, { useEffect } from "react"
import tw from "twin.macro"
import { graphql } from "gatsby"
import Layout from "components/Layout"
import SeoHead from "components/SEO"
import styled from "styled-components"
import Container from "components/Container"

const StyledWrapper = styled(Container)`
  ${tw`px-8`}

  ${(props) => props.theme.media.tablet_landscape_up`
    ${tw`px-20`}
  `}
`

const Cookies = ({ ...props }) => {
  const { data: site_settings } = props.data.prismicSiteSettings

  function createMarkup() {
    return {
      __html:
        '<script id="CookieDeclaration" src="https://consent.cookiebot.com/859afa55-df6a-4946-847e-ef081acc94e0/cd.js" type="text/javascript"></script>',
    }
  }

  useEffect(() => {
    if (typeof window !== "undefined") {
      const cd = document.createElement("script")
      cd.src =
        "https://consent.cookiebot.com/859afa55-df6a-4946-847e-ef081acc94e0/cd.js"
      document.body.appendChild(cd)
    }
  }, [])

  return (
    <Layout site_settings={site_settings} lang="da-dk">
      <StyledWrapper>
        <h1 tw="font-bold inline-block text-6xl md:text-6xl">Cookies</h1>
        <div dangerouslySetInnerHTML={createMarkup()} />
      </StyledWrapper>
    </Layout>
  )
}

export default Cookies

export const Head = ({ data }) => (
  <SeoHead
    siteMetadata={data.site.siteMetadata}
    siteSettings={data.prismicSiteSettings}
    title="Cookiepolitik"
    schemaTitle="Cookiepolitik"
    description="Læs Clevertracks cookiepolitik."
    slug="/cookies"
    lang="da-dk"
  />
)

export const query = graphql`
  query CookiesPage {
    site {
      ...SiteSeoMetadata
    }
    prismicSiteSettings {
      _previewable
      ...SiteNavigation
      ...FooterInformation
      ...FooterNavigation
      ...SocialMediaLinks
      ...UtilityNavigation
    }
  }
`
